/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_Bar_FinishedInputs */



/**
* | output |
* | --- |
* | "Tournament complete." |
*
* @param {Action_Bar_FinishedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const action_bar_finished = /** @type {((inputs?: Action_Bar_FinishedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_Bar_FinishedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tournoi terminé.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Torneo finalizado.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Torneio finalizado.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Torneo completato.")
	return /** @type {LocalizedString} */ ("Tournament complete.")
});